import { useMemo } from 'react';
import {
  Day,
  Inject,
  RenderCellEventArgs,
  ResourceDirective,
  ResourcesDirective,
  ScheduleComponent,
} from '@syncfusion/ej2-react-schedule';
import { addClass } from '@syncfusion/ej2-base';
import './syncfusion-plain-debug.css';

const SyncfusionPlainDebugPage = () => {
  const selectedDate = useMemo(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }, []);

  const day = selectedDate.getDay();

  const resources = useMemo(
    () => [
      { id: 1, text: 'Dr Harrison Mihailidis', color: '#ea7a57', workDays: [day], startHour: '08:00', endHour: '12:00' },
      { id: 2, text: 'Dr Paul Verrills', color: 'rgb(53, 124, 210)', workDays: [day], startHour: '09:00', endHour: '15:00' },
      { id: 3, text: 'Dr Anthony Zandes', color: '#7fa900', workDays: [day], startHour: '10:00', endHour: '16:00' },
    ],
    [day],
  );

  const events = useMemo(
    () => [
      {
        Id: 1001,
        Subject: 'Static A',
        StartTime: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 9, 15),
        EndTime: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 9, 45),
        DoctorId: 1,
      },
      {
        Id: 1002,
        Subject: 'Static B',
        StartTime: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 11, 0),
        EndTime: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 11, 30),
        DoctorId: 2,
      },
      {
        Id: 1003,
        Subject: 'Static C',
        StartTime: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 13, 0),
        EndTime: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 13, 30),
        DoctorId: 3,
      },
    ],
    [selectedDate],
  );

  const onRenderCell = (args: RenderCellEventArgs) => {
    if (!args.element) return;
    if (!args.element.classList.contains('e-work-cells') && !args.element.classList.contains('e-work-hours')) return;

    const groupIndex = parseInt(args.element.getAttribute('data-group-index') || '-1', 10);
    if (Number.isNaN(groupIndex) || groupIndex < 0) return;

    addClass([args.element], [`sf-doc-${groupIndex}`]);
  };

  return (
    <div className="sf-plain-page">
      <h1>Syncfusion Plain Debug Page</h1>
      <p>Standalone page, static data only, outside project layout/theming.</p>

      <div className="sf-plain-wrap">
        <ScheduleComponent
          height="760px"
          width="100%"
          selectedDate={selectedDate}
          currentView="Day"
          startHour="07:00"
          endHour="18:00"
          workHours={{ highlight: true }}
          group={{ resources: ['Doctors'], byDate: false }}
          renderCell={onRenderCell}
          cssClass="sf-plain-scheduler"
          eventSettings={{
            dataSource: events,
            fields: {
              id: 'Id',
              subject: { name: 'Subject' },
              startTime: { name: 'StartTime' },
              endTime: { name: 'EndTime' },
              resourceId: { name: 'DoctorId' },
            },
          }}
        >
          <ResourcesDirective>
            <ResourceDirective
              field="DoctorId"
              title="Doctors"
              name="Doctors"
              dataSource={resources}
              textField="text"
              idField="id"
              colorField="color"
              workDaysField="workDays"
              startHourField="startHour"
              endHourField="endHour"
            />
          </ResourcesDirective>
          <Inject services={[Day]} />
        </ScheduleComponent>
      </div>
    </div>
  );
};

export default SyncfusionPlainDebugPage;
